import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import icons from './icons-map.json';

/**
 * Inject IconsService anywhere in the application and call registerIcons()
 * It will register all available icons as Material Icons.
 *
 * Usage: `<mat-icon svgIcon="ICON_NAME"></mat-icon>`
 */
@Injectable({
  providedIn: 'root',
})
export class IconsService {
  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
  ) {}

  registerIcons() {
    const svg = icons;
    Object.entries(svg).forEach(([key, path]: [string, string]) => {
      this.iconRegistry.addSvgIcon(
        key,
        this.sanitizer.bypassSecurityTrustResourceUrl(path),
      );
    });
  }
}
